import { render, staticRenderFns } from "./placeorder1.vue?vue&type=template&id=5de9534a&scoped=true&"
import script from "./placeorder1.vue?vue&type=script&lang=js&"
export * from "./placeorder1.vue?vue&type=script&lang=js&"
import style0 from "./placeorder1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./placeorder1.vue?vue&type=style&index=1&id=5de9534a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de9534a",
  null
  
)

export default component.exports